import { render } from "./TgPanel.vue?vue&type=template&id=5be2a975"
import script from "./TgPanel.vue?vue&type=script&lang=js"
export * from "./TgPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__